import { render, staticRenderFns } from "./modal-story.vue?vue&type=template&id=a2867a9a&scoped=true&"
import script from "./modal-story.vue?vue&type=script&lang=js&"
export * from "./modal-story.vue?vue&type=script&lang=js&"
import style0 from "./modal-story.vue?vue&type=style&index=0&id=a2867a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2867a9a",
  null
  
)

export default component.exports